const template = window.theme ? window.theme.template : null;
const pageType = window.theme ? window.theme.pageType : null;
const isCheckout = Shopify ? Shopify.Checkout : null;
 

if (template.includes('product')) {
  import("./scripts/accordionSectionPosition").then(function (page) {
    document.dispatchEvent(new CustomEvent('script:added'));
  });
}
import('./scripts/estimate-delivery');
import('./scripts/autoGift');
import('./scripts/logosSection');
